import api from './instanceApi';

export const mainApi = {
  fetchUserList: (year, month, forceRefresh = false) => 
    api.post('/main', { 
      year, 
      month,
      forceRefresh: forceRefresh // 캐시 방지용 파라미터 추가
    }, {
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0'
      }
    })
    .then(response => response.data.data || {}),

  fetchUserDetails: (name, year, month) =>
    api.post('/main/results', {
      name,
      check_year: year,
      check_month: month
    }, {
      timeout: 5000,
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0'
      }
    })
    .then(response => response.data)
    .catch(error => {
      console.error('상세 정보 조회 실패:', error);
      throw error; 
    }),
    
  // 예외처리 정보와 상태 변경을 함께 저장하는 API
  saveExceptionStatus: (data) => {
    return api.post('/main/exception', {
      userName: data.userName,
      year: data.year,
      month: data.month,
      isException: data.isException ? 'Y' : 'N', 
      exceptionReason: data.exceptionReason || '',
      check_status: data.check_status || '' 
    })
    .then(response => {
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error('예외처리 정보 저장에 실패했습니다');
      }
    })
    .catch(error => {
      console.error('예외처리 정보 저장 실패:', error);
      throw error;
    });
  },
    
  downloadFile: (params) => {
    return api.post('/alerts/downloadFile', {
      file_id: params.file_id,
      department: params.department,
      name: params.name,
      year: params.year,
      month: params.month
    })
    .then(response => {
      if (response.status === 200) {
        return response;
      } else {
        throw new Error('파일을 찾을 수 없습니다.');
      }
    })
    .catch(error => {
      console.error('파일 다운로드 실패:', error);
      throw error;
    });
  }
};